// Request and response (TODO) handling
/* Request
  params:
    - url: string - endpoint to make request
    - method: string - REST Operation
    - data: Object - Body data that is automatically converserted to JSON.stringify
    - addedHeaders: Array - Array of added headers
  returns: fetch request object
*/
// import { getUserData } from '../../../services/userservice';

const requestHandler = async (url, method, data, addedHeaders = {
}) => {
  const headers = {
    ...addedHeaders,
  };
  // const storage = JSON.parse(localStorage.getItem('persist:root'));
  // const session = JSON.parse(storage.session);

  // const user = await getUserData(session.user_token);
  // if (user.error) {
  //   return user.error;
  // }
  headers.Accept = 'application/json';
  headers['Content-Type'] = 'application/json';
  headers.token = process.env.REACT_APP_TOKEN;
  const request = {
    headers,
    method,
  };
  if (data) {
    request.body = JSON.stringify(data);
  }
  return fetch(url, request);
};

const responseHandler = (response, isjson = true) => {
  if (! isjson) return response;
  if (response.ok) {
    return response.status === 204 ? true : response.json().then(data => data);
  } if (response.status === 401) {
    return response.json().then((err) => {
      throw err;
    });
  }
  return false;
};

export {
  requestHandler,
  responseHandler,
};
